import { queryOptions } from "@tanstack/react-query";
import { AUTH_MY_INFO_QUERY_KEY } from "../queryClient";
import { getMyInfo, joinTerm, joinTermList, joinTermNoticeDates } from "../v1/auth.service";

export const useJoinTermsList = () => queryOptions({
    queryKey: ["join-terms-list"],
    queryFn: () => joinTermList(),
    retry: 1
})

export const useJoinTermNoticeDates = (type: string) => queryOptions({
    queryKey: ["join-term-notice-dates", type],
    queryFn: () => joinTermNoticeDates(type),
    enabled: !!type,
    retry: 1
})

export const useJoinTerm = (type: string, noticeDate: string) => queryOptions({
    queryKey: ["join-term", type, noticeDate],
    queryFn: () => joinTerm(type, noticeDate),
    enabled: !!type && !!noticeDate,
    retry: 1
})

export const useMyInfo = () => queryOptions({
    queryKey: AUTH_MY_INFO_QUERY_KEY,
    queryFn: () => getMyInfo(),
    retry: 1
})